import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getExternalFinishingDetails } from "../../helpers/http_external_finishings_requests";
import { useQuery } from "@tanstack/react-query";

export default function ExternalFinishingDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({ 
        queryKey: ['getExternalFinishingDetails', id], 
        queryFn: () => getExternalFinishingDetails(id), 
        staleTime: 1000 * 5 
    });

    const { data: externalFinishingData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Acabamento Externo - Detalhes",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage 
        isLoading={isFetching} 
        details 
        initialData={externalFinishingData} 
        title={"Acabamento Externo - Detalhes"} 
        formFieldList={formFieldList} 
        onCancel={() => navigate(-1)} 
    />;
}
